import {withMeta, withSystem} from '@packages/systems/wfdl';
import {excludeSearchByDefaultType} from '@packages/systems/search';
import {
  TBoolean,
  TText,
  TRecord,
  TUnionWithLabels,
  TEnum,
} from '@packages/systems/wfdl-ast';

// Show Count segmented control
// Used by Follow Button mode
const show_count = withSystem(
  {
    defaultValue: 'true',
    label: 'Bubble',
  },
  TEnum({
    true: 'Show',
    false: 'Hide',
  })
);

// Show Count segmented control
// Used by Tweet Button mode
const show_count_union = withSystem(
  {
    label: 'Bubble',
  },
  TUnionWithLabels({
    true: {
      label: 'Show',
      type: TRecord({
        // Used to indicate whether to use horizontal or vertical layout
        // Vertical layout has since been removed from Twitter API so we've
        // shimmed it in Twitter.tsx is order to preserve the layout on
        // user's existing sites.
        // https://github.com/webflow/webflow/issues/3322
        __deprecated__count_layout: withSystem(
          {defaultValue: 'horizontal', label: 'Layout'},
          TEnum({
            horizontal: 'Horizontal',
            vertical: 'Vertical',
          })
        ),
      }),
    },
    false: {
      label: 'Hide',
      type: withSystem(
        {defaultValue: 'false', private: true, label: ''},
        TText
      ),
    },
  })
);

// Size segmented control
// Used for both Tweet and Follow mode
const size = withSystem(
  {
    defaultValue: 'm',
    label: 'Size',
  },
  TEnum({
    m: 'Regular',
    l: 'Large',
  })
);

// Tweet Button mode
const tweet = {
  label: 'Tweet',
  type: TRecord({
    url: withMeta(
      {placeholder: 'webflow.com'},
      withSystem({label: 'Share URL', isFullWidth: true}, TText)
    ),
    text: withMeta(
      {placeholder: 'Check out this site'},
      withSystem({label: 'Tweet Text', isFullWidth: true}, TText)
    ),
    show_count: show_count_union,
  }),
} as const;

// Follow button mode
const follow = {
  label: 'Follow',
  type: TRecord({
    screen_name: withMeta(
      {placeholder: 'webflow'},
      withSystem({label: 'User @'}, TText)
    ),
    show_count,
  }),
} as const;

const dataTypeFields = {
  search: withSystem(
    {private: true},
    TRecord({
      exclude: excludeSearchByDefaultType,
    })
  ),
  value: withSystem({private: true}, TText),
  widget: TRecord({
    mode: withSystem(
      {label: 'Button', defaultValue: {tag: 'tweet'}},
      TUnionWithLabels({
        tweet,
        follow,
      })
    ),
    size,
    type: withSystem(
      {
        defaultValue: 'twitter',
        private: true,
        label: '',
      },
      TText
    ),
    html: withSystem(
      {
        defaultValue: true,
        private: true,
        label: '',
      },
      TBoolean
    ),
  }),
} as const;

export default dataTypeFields;
